<!--suppress AngularUndefinedBinding -->
<nav class="breadcrumb-one" aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a href="javascript:void(0);">
        <svg class="feather feather-home" fill="none" height="24" stroke="currentColor"
             stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
          <polyline points="9 22 9 12 15 12 15 22"></polyline>
        </svg>
      </a>
    </li>
    <li class="breadcrumb-item active" aria-current="page" translate>Sub Accounts</li>
  </ol>
</nav>
<div [hidden]="loading" class="row layout-spacing layout-top-spacing">
  <div class="col-lg-12 rounded-circle p-2">
    <div class="row bg-white p-2 text-primary">
      <div class="col-2" translate>Request No</div>
      <div class="col-2" translate>Date</div>
      <div class="col-1" translate>Count</div>
      <div class="col-2" translate>Total</div>
      <div class="col-2" translate>VAT Amount</div>
      <div class="col-2" translate>Status</div>
      <div class="col-1" translate>Action</div>
    </div>
    <div class="row bg-white p-2" *ngFor="let c of newSubAccountsRequests">
      <div class="col-2" translate>{{c.id}}</div>
      <div class="col-2" translate>{{c.createDate}}</div>
      <div class="col-1" translate>{{c.count}}</div>
      <div class="col-2" translate>{{c.totalAmount | number:'1.2-2'}} <sup><img height="18" src="assets/sr.svg"></sup></div>
      <div class="col-2" translate>{{c.totalVatAmount | number:'1.2-2'}} <sup><img height="18" src="assets/sr.svg"></sup></div>
      <div class="col-2" translate>{{checkStatus(c) | translate}}</div>
      <div class="col-1" translate>
        <a *ngIf="checkStatus(c) != 'Used'" (click)="viewRequest(c)" href="javascript:void(0);" translate>View</a>
        <a *ngIf="checkStatus(c) == 'Used'" (click)="viewUsed(c)" href="javascript:void(0);" translate>View</a>
        <!--        <div class="dropdown">-->
        <!--          <a class="dropdown-toggle" href="javascript:void(0)" role="button" [id]="'dropdownMenuLink_' + c.id" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">-->
        <!--            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-more-horizontal">-->
        <!--              <circle cx="12" cy="12" r="1"></circle>-->
        <!--              <circle cx="19" cy="12" r="1"></circle>-->
        <!--              <circle cx="5" cy="12" r="1"></circle>-->
        <!--            </svg>-->
        <!--          </a>-->
        <!--          <div class="dropdown-menu" [attr.aria-labelledby]="'dropdownMenuLink_' + c.id">-->
        <!--            <a class="dropdown-item" *ngIf="checkStatus(c) == 'Pending Approval' || checkStatus(c) == 'Pending Payment'" (click)="cancelRequest(c)" href="javascript:void(0);" translate>Cancel</a>-->
        <!--            <a class="dropdown-item" *ngIf="checkStatus(c) != 'Used'" (click)="viewRequest(c)" href="javascript:void(0);" translate>View</a>-->
        <!--            <a class="dropdown-item" *ngIf="checkStatus(c) == 'Used'" (click)="viewUsed(c)" href="javascript:void(0);" translate>View</a>-->
        <!--            <a class="dropdown-item" *ngIf="checkStatus(c) == 'Pending Payment'" (click)="payRequest(c)" href="javascript:void(0);" translate>Pay</a>-->
        <!--            <a class="dropdown-item" *ngIf="checkStatus(c) == 'Ready To Use'" (click)="useRequest(c)" href="javascript:void(0);" translate>Use the request</a>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
    </div>
  </div>
</div>
<div *ngIf="loading">
  <div class="d-flex">
    <div class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
  </div>
</div>
<app-new-sub-account-details #newSubAccountDetails></app-new-sub-account-details>
